import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from "@angular/core";
import { IDriver } from "@interfaces/IDriver";
import { DriverService } from "@services/driver.service";
import "./v-driver-autocomplete.component.scss";

@Component({
    selector: "v-driver-autocomplete",
    template: require('./v-driver-autocomplete.component.html')
})
export class VDriverAutocompleteComponent implements OnChanges {
    @Input() driver: IDriver;
    @Input() selectedDriverId: string;
    @Output() selectedDriverIdChange: EventEmitter<string> = new EventEmitter();

    @Output() driverSelected: EventEmitter<IDriver> = new EventEmitter();
    @Output() clear = new EventEmitter<void>();

    @Input() label: string = "Driver";
    @Input() placeholder: string = "Select Driver";

    @ViewChild('autoCompleteInput') autoCompleteInput: any;

    // ---

    text: string = '';
    driverPromise: angular.IPromise<IDriver[]>;

    constructor(private readonly driverService: DriverService) {
    }

    ngOnChanges() {
        if (this.selectedDriverId) {
            this.loadData();
        }
    }

    onCleared(): void {
        this.text = '';
        this.selectedDriverId = null;
        this.selectedDriverIdChange.emit(null);
        this.clear.emit();
    }

    onFocus() {
        this.loadData();
    }

    onDriverClicked(driver: IDriver) {
        this.text = driver.Name;
        this.driverSelected.emit(driver);
    }

    onTextChanged(text: string) {
        this.text = text;

        if ((!text || text.trim() === '') && this.selectedDriverId) {
            this.selectedDriverId = null;
            this.selectedDriverIdChange.emit(null);
            this.clear.emit();
        }
    }

    driverFilter = (driver: IDriver, text: string): boolean => {

        // This should be a common method somewhere else...
        return driver.Name.toLowerCase().indexOf(text) >= 0;
    }

    // ---

    private loadData() {
        this.driverPromise = this.driverService.getDrivers();
    }
}
